var _path, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasswordToggleVisible(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.52487C9 1.52487 4.73 4.63487 3 9.02487C4.73 13.4149 9 16.5249 14 16.5249C19 16.5249 23.27 13.4149 25 9.02487C23.27 4.63487 19 1.52487 14 1.52487ZM14 14.0249C11.24 14.0249 9 11.7849 9 9.02487C9 6.26487 11.24 4.02487 14 4.02487C16.76 4.02487 19 6.26487 19 9.02487C19 11.7849 16.76 14.0249 14 14.0249ZM14 6.02487C12.34 6.02487 11 7.36487 11 9.02487C11 10.6849 12.34 12.0249 14 12.0249C15.66 12.0249 17 10.6849 17 9.02487C17 7.36487 15.66 6.02487 14 6.02487Z",
    fill: "white",
    fillOpacity: 0.56
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.739502,
    y1: 1.22828,
    x2: 27.5863,
    y2: 16.7283,
    stroke: "white",
    strokeOpacity: 0.56,
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordToggleVisible);
export default __webpack_public_path__ + "static/media/password-toggle-visible.fcb585f654277160c679276a8b9ffa04.svg";
export { ForwardRef as ReactComponent };